var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Callout, Checkbox, Classes, Dialog, FormGroup, H5, InputGroup, Intent, Toaster, } from '@blueprintjs/core';
import { mdiAccount, mdiAlert, mdiCheck, mdiLockCheck } from '@mdi/js';
import { LG, LO } from 'big-l';
import { Auth } from 'katal3-client';
import { Component } from 'react';
import { connect } from 'react-redux';
import IKon from './IKon';
const LGR = LG.ns('AuthDialog');
const defaultAuthDialogState = {
    username: '',
    password: '',
    stay: false,
    formErrors: {},
};
class AuthDialog extends Component {
    constructor() {
        super(...arguments);
        this.state = defaultAuthDialogState;
        this.toaster = null;
    }
    componentDidMount() {
        this.setState(defaultAuthDialogState);
    }
    handleFormSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            let { username, password, stay } = this.state;
            let formErrors = {};
            if (!username.length)
                formErrors['username'] = { intent: Intent.DANGER, message: "Nom d'utilisateur manquant" };
            if (!password.length)
                formErrors['password'] = { intent: Intent.DANGER, message: 'Mot de passe manquant' };
            if (LO.isEmpty(formErrors)) {
                yield this.props.login(username, password, stay);
            }
            else {
                this.setState({ formErrors });
            }
        });
    }
    handleKeyDown(e) {
        if (e.key == 'Enter') {
            this.handleFormSubmit();
        }
    }
    componentDidUpdate(oldProps) {
        var _a;
        let { error } = this.props;
        if (error !== oldProps.error) {
            LGR.debug('Auth dialog error updated from', oldProps.error, 'to', error);
            switch (error === null || error === void 0 ? void 0 : error.type) {
                case Auth.ErrorType.NOT_ALLOWED:
                    this.setState({ message: error.message, intent: Intent.DANGER });
                    break;
                case undefined:
                    this.setState({ message: undefined, intent: undefined });
                    break;
                default:
                    (_a = this.toaster) === null || _a === void 0 ? void 0 : _a.show({ message: error === null || error === void 0 ? void 0 : error.message, intent: Intent.DANGER });
                    break;
            }
        }
    }
    render() {
        var _a, _b, _c, _d, _e, _f;
        const { username, password, stay, formErrors, message, intent } = this.state;
        const { user, loading, error, ready } = this.props;
        let display = !user || !!error;
        return (_jsxs(_Fragment, { children: [_jsx(Toaster, { ref: ref => {
                        this.toaster = ref;
                    }, className: 'top-portal' }, void 0), _jsxs(Dialog, Object.assign({ backdropClassName: 'auth-backdrop', isOpen: display, portalClassName: 'top-portal', className: 'login' }, { children: [_jsxs("div", Object.assign({ className: Classes.DIALOG_HEADER }, { children: [_jsx(H5, { children: "Katal" }, void 0), _jsx("div", { className: 'spacer' }, void 0), _jsx("span", Object.assign({ className: 'legend' }, { children: "Connexion" }), void 0)] }), void 0), _jsx("div", Object.assign({ className: Classes.DIALOG_BODY }, { children: _jsxs("form", { children: [message ? (_jsx(Callout, Object.assign({ intent: intent, icon: _jsx(IKon, { icon: mdiAlert, size: 20 }, void 0) }, { children: message }), void 0)) : null, _jsx(FormGroup, Object.assign({ disabled: loading, intent: (_a = formErrors['username']) === null || _a === void 0 ? void 0 : _a.intent, helperText: (_b = formErrors['username']) === null || _b === void 0 ? void 0 : _b.message }, { children: _jsx(InputGroup, { disabled: loading, leftElement: _jsx(IKon, { icon: mdiAccount, size: 16 }, void 0), placeholder: "Nom d'utilisateur / E-mail", value: username, autoComplete: 'username', onChange: (evt) => this.setState({ username: evt.currentTarget.value }), onKeyDown: evt => this.handleKeyDown(evt), intent: (_c = formErrors['username']) === null || _c === void 0 ? void 0 : _c.intent }, void 0) }), void 0), _jsx(FormGroup, Object.assign({ disabled: loading, intent: (_d = formErrors['password']) === null || _d === void 0 ? void 0 : _d.intent, helperText: (_e = formErrors['password']) === null || _e === void 0 ? void 0 : _e.message }, { children: _jsx(InputGroup, { disabled: loading, leftElement: _jsx(IKon, { icon: mdiLockCheck, size: 16 }, void 0), placeholder: 'Mot de passe', type: 'password', autoComplete: 'current-password', value: password, onChange: (evt) => this.setState({ password: evt.currentTarget.value }), onKeyDown: evt => this.handleKeyDown(evt), intent: (_f = formErrors['password']) === null || _f === void 0 ? void 0 : _f.intent }, void 0) }), void 0)] }, void 0) }), void 0), _jsxs("div", Object.assign({ className: Classes.DIALOG_FOOTER }, { children: [_jsx("div", Object.assign({ className: 'options' }, { children: _jsx(Checkbox, { label: 'Rester connect\u00E9', checked: stay, onChange: e => this.setState({ stay: e.currentTarget.checked }) }, void 0) }), void 0), _jsx("div", Object.assign({ className: Classes.DIALOG_FOOTER_ACTIONS }, { children: _jsx(Button, Object.assign({ disabled: loading, icon: _jsx(IKon, { icon: mdiCheck, size: 20 }, void 0), intent: Intent.PRIMARY, onClick: () => this.handleFormSubmit() }, { children: "Se connecter" }), void 0) }), void 0)] }), void 0)] }), void 0)] }, void 0));
    }
}
const mapState = (state) => ({
    loading: state.auth.loading,
    user: state.auth.user,
    error: state.auth.error,
    ready: state.auth.ready,
});
const mapDispatch = (dispatch) => ({
    login: (user, pass, stay = false) => dispatch(Auth.login(user, pass, stay)),
});
const connector = connect(mapState, mapDispatch);
export default connector(AuthDialog);
